import React from 'react';

import TransactionRow from './TransactionRow';

export default function TransactionTable({ transactions, categories }) {

    return (
        <table>
            {
                transactions.map((item, index) => (
                    <TransactionRow categories={categories} transaction={item} key={index} />
                ))
            }
        </table>
    )
}
